/*=========================================================================================
  File Name: moduleStaff.js
  Description: Staff Module
  ----------------------------------------------------------------------------------------
  Item Name: Speed HRM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleIngredientsState'
import mutations from './moduleIngredientsMutations.js'
import actions from './moduleIngredientsActions.js'
import getters from './moduleIngredientsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}